import { AfterViewInit, Component, Input } from '@angular/core';
import { MenuItem } from '@teorema/patron';
import { Ticket } from 'src/app/models';
import { TcTicketService } from 'src/app/shared/services';

@Component({
  selector: 'app-sprint-context-menu',
  templateUrl: './sprint-context-menu.component.html',
  styles: [],
  standalone: false,
})
export class SprintContextMenuComponent implements AfterViewInit {
  @Input() ticket!: Ticket;
  @Input() target?: any;
  @Input() readOnly: boolean = false;

  menuItems: MenuItem[] = [];

  constructor(private tcTicketService: TcTicketService) {}

  ngAfterViewInit(): void {
    let link = '';
    if (!this.readOnly) {
      link = window.location.origin + '/v3ndor/chamados/' + this.ticket.id;
      this.menuItems.push({
        label: 'Abrir em uma nova guia',
        command: () => this.openInNewTab(link),
      });
    } else {
      link = `https://catalogo.teorema.inf.br/chamadas/${this.ticket.id}`;
      this.menuItems.push({
        label: 'Abrir no catálogo',
        command: () => this.openInNewTab(link),
      });
    }

    this.menuItems.push(
      ...[
        {
          label: 'Copiar número',
          command: () => this.tcTicketService.copyTicketNumber(this.ticket),
        },
        {
          label: 'Copiar recado (Privado)',
          command: () =>
            this.tcTicketService.copyNote(
              false,
              this.ticket,
              window.location.origin + '/v3ndor/chamados/' + this.ticket.ticket_number_teorema
            ),
        },
        {
          label: 'Copiar recado (Público)',
          command: () => this.tcTicketService.copyNote(true, this.ticket),
        },
      ]
    );
  }

  openInNewTab(link: string) {
    window.open(link, '_blank');
  }
}
